import { z } from 'zod';

export const AhqFindContactSchema = z.object({
  contactId: z.string().uuid(),
});
export type AhqFindContact = z.infer<typeof AhqFindContactSchema>;
